import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=07f37d83&scoped=true"
import script from "./CalendarIcon.vue?vue&type=script&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&lang=js"
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=07f37d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f37d83",
  null
  
)

export default component.exports